import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import 'assets/plugins/nucleo/css/nucleo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'assets/scss/argon-dashboard-react.scss';
import 'assets/css/custom.css';

import AdminLayout from 'layouts/Admin.js';
import AuthLayout from 'layouts/Auth.js';

import { isAuthenticated } from './services/auth.js';
import { ToastContainer } from 'react-toastify';
import { IntlProviderWrapper } from 'utility/Internacionalization.js';
import { SaleProvider } from 'views/system/Sale/sale-table-context.js';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <>
    <SaleProvider>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated() ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{ pathname: '/auth', state: { from: props.location } }}
            />
          )
        }
      />
    </SaleProvider>
  </>
);

ReactDOM.render(
  <IntlProviderWrapper>
    <BrowserRouter>
      <Switch>
        <PrivateRoute
          path='/admin'
          component={(props) => <AdminLayout {...props} />}
        />
        <Route path='/auth' render={(props) => <AuthLayout {...props} />} />
        <Redirect from='/' to='/auth' />
      </Switch>
    </BrowserRouter>
  </IntlProviderWrapper>,
  document.getElementById('root')
);
